import { VesselModel } from 'models/VesselModel';

export type CompanyData = {
    name: string,
    alias?: string,
    phone: string,
    fax: string,
    email: string,
    country?: string,
    utcOffset?: number,
    zipCode: string,
    city: string,
    address: string,
    addressJa?: string,
    exporterCode: string,
    shipperCode?: string,
    qisNumber?: string,
}

export type CompanyModel = CompanyData & {
    id: number,
    cleanName: string,
    balance: number,
    freeBalance: number,
    stamp?: string,
    logo?: string,
    active: boolean,
    type: CompanyType,
    usersCount: number,
    carsCount: {[status: string]: number}
    vessels?: VesselModel[],
}

export enum CompanyType {
    Master = 'master',
    Shipper = 'shipper',
    PortAgent = 'port_agent',
    TransportAgent = 'transport_agent',
    Party = 'party',
    VesselOwner = 'vessel_owner',
}
